import store from 'store2';

const filtersCacheStorage = store.namespace('FILTERS');

export function createLocalStorageCacheProvider(key) {
  return {
    get() {
      return filtersCacheStorage.local.get(key) || {};
    },
    set(cache) {
      return filtersCacheStorage.local.set(key, cache);
    },
    transact(fn) {
      return filtersCacheStorage.local.transact(key, fn);
    }
  };
}

export function createSessionStorageCacheProvider(key) {
  return {
    get() {
      return filtersCacheStorage.session.get(key) || {};
    },
    set(cache) {
      return filtersCacheStorage.session.set(key, cache);
    },
    transact(fn) {
      return filtersCacheStorage.session.transact(key, fn);
    }
  };
}

export default filtersCacheStorage;
